import { Box, Dialog, DialogActions, DialogContent, Typography } from "@mui/material"
import { WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { SelectedLot } from "./hooks/useInventoryAdjustmentPalletGroupSelection"

import { Button } from "@/components/common/Button"

interface InventoryAdjustmentUntestedLotsDialogProps {
  untestedLots: SelectedLot[]
  onClose: () => void
}

export const InventoryAdjustmentUntestedLotsDialog: FC<InventoryAdjustmentUntestedLotsDialogProps> = ({
  untestedLots,
  onClose,
}) => (
  <Dialog open onClose={onClose} data-testid='inventory-adjustment.untested-lots-dialog'>
    <DialogContent classes={{ root: "p-10" }}>
      <Box className='mb-6 w-full justify-center text-center'>
        <WarningOutlined className='size-12 text-secondary-600' />
        <Typography
          data-testid='inventory-adjustment.untested-lots-dialog.title'
          variant='h5'
          color='primary'
          className='mt-6 font-normal'
          component='h2'
        >
          Lot Numbers Not Found
        </Typography>
      </Box>
      <Box
        className='mt-6 px-3 text-center text-base leading-[150%] tracking-[-0.85px] text-gray-700'
        data-testid='inventory-adjustment.untested-lots-dialog.content'
      >
        <p className='mb-4'>
          The selected Lot # / Batch # does not exist for this product. Please add the Lot # / Batch # to the product
          before continuing with the adjustment.
        </p>
        <ul className='list-disc px-4 text-left font-normal'>
          {untestedLots.map(({ lot, pallet }) => (
            <li
              key={lot.rawInventoryId}
              data-testid={`inventory-adjustment.untested-lots-dialog.lot-${lot.rawInventoryId}`}
            >
              Lot #<b>{lot.lotNbr}</b>
              {lot.batchNbr && (
                <>
                  , Batch #<b>{lot.batchNbr}</b>
                </>
              )}{" "}
              for Pallet Reference #<b>{pallet.referenceNbr}</b>
            </li>
          ))}
        </ul>
      </Box>
    </DialogContent>
    <DialogActions className='justify-end px-10 pb-10 pt-0'>
      <Button data-testid='inventory-adjustment.untested-lots-dialog.submit-button' variant='primary' onClick={onClose}>
        OK
      </Button>
    </DialogActions>
  </Dialog>
)
